import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { PollComponent } from 'src/app/modules/pages/poll/poll.component';
import { AuthGuard } from 'src/app/core/auth/auth.guard';
import { PollShowLayoutComponent } from './poll-show-layout.component';
import { PollShowHeaderComponent } from 'src/app/core/headers/poll-show-header/poll-show-header.component';
import { StringPollWidget } from 'src/app/shared/widgets/schemaPoll/string/string.component';
import { RadioPollWidget } from 'src/app/shared/widgets/schemaPoll/radio/radio.widget';
import { DatePollWidget } from 'src/app/shared/widgets/schemaPoll/date/date.component';
import { CheckboxPollWidget } from 'src/app/shared/widgets/schemaPoll/checkbox/checkbox.component';
import { TextareaPollWidget } from 'src/app/shared/widgets/schemaPoll/textarea/textarea.component';
import { LoginComponent } from 'src/app/modules/components/login/login.component';
import { SchemaFormModule, WidgetRegistry, DefaultWidgetRegistry } from 'ngx-schema-form';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginModule } from 'src/app/modules/components/login/login.module';
import { MaterialModule } from 'src/app/material-module';
import { WidgetRegistryPoll } from 'src/app/shared/widgets/schemaPoll/WidgetRegisty';


const routes: Routes = [
  {
    path: '',
    component: PollComponent,
  }  
]

@NgModule({
  declarations: [
    PollShowLayoutComponent,
    PollShowHeaderComponent,
    PollComponent,
    StringPollWidget,
    RadioPollWidget,
    DatePollWidget,
    CheckboxPollWidget,
    TextareaPollWidget
  ],
  entryComponents: [
      LoginComponent,
      PollComponent

  ],
  imports: [
    SchemaFormModule.forRoot(),
    CommonModule,
    RouterModule.forChild(routes),
    HttpClientModule,
    FormsModule,
    LoginModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  providers: [
    {
        provide: WidgetRegistry,
        useClass: WidgetRegistryPoll,
    }
  ],
  exports: [
    PollShowLayoutComponent
  ]
})
export class PollShowLayoutModule { }
